import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

import { RouteSegments } from '@shared/enums';

import { environment } from '@environments/environment';

const isAccessAllowed = async (_: ActivatedRouteSnapshot, __: RouterStateSnapshot, authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const { authenticated } = authData;

  const router = inject(Router);

  if (environment.enableLogin && !authenticated)
    return router.createUrlTree([RouteSegments.Root, RouteSegments.Public, RouteSegments.PlatformOverview]);

  return true;
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
